// extracted by mini-css-extract-plugin
export default {"wrapper":"appSearchInput_wrapper__GYMHm","wrapper__searchIcon":"appSearchInput_wrapper__searchIcon__WM65j"};